import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        red: '#f00',
        primary: '#007CB7',
        secondary: '#4CAF50',
        accent: '#007CB7',
      },
    },
  },
})
